// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const GROUP_MODERATOR_SHORT = "Moder\u00e1tor";
export const PB_POST_HAS_BEEN_EDITED = "Spr\u00e1va bola zmenen\u00e1";
export const POST_DELETED_BECAUSE_reason = "D\u00f4vod: %(reason)s";
export const POST_DELETED_BY_ADMIN = "Pr\u00edspevok zmazan\u00fd adminom";
export const POST_DELETED_BY_AUTHOR = "Pr\u00edspevok zmazan\u00fd autorom";
export const POST_DELETED_BY_MODERATOR = "Pr\u00edspevok zmazan\u00fd moder\u00e1torkou";
export const POST_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie pr\u00edspevku";
export const SHOW = "Zobraz";
export const SHOW_FULL_MESSAGE = "Zobraz cel\u00fa spr\u00e1vu";
